export default __webpack_public_path__ + "static/media/ON.af33f3dc.jpg";